module.exports = __webpack_public_path__ + "static/media/cart-thin.c06d8e19.svg";